import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=1059c4ba&scoped=true&"
import script from "./Success.vue?vue&type=script&lang=ts&"
export * from "./Success.vue?vue&type=script&lang=ts&"
import style0 from "./Success.vue?vue&type=style&index=0&id=1059c4ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1059c4ba",
  null
  
)

export default component.exports